<template>
  <div>
    <a v-if="this.ClassTools!=7&&this.ClassTools!=8&&this.ClassTools!=9&&this.ClassTools!=10&&this.ClassTools!=11">{{ (this.$store.getters['classTool/parse'](this.info.ClassTools))==null?'':(this.$store.getters['classTool/parse'](this.info.ClassTools))["name"]}}</a>
       <!-- @click="JoinClassIn()">{{this.info.VirtualPhone}}/{{this.info.VirtualPassword}} -->
    <v-layout fluid
              wrap>
      <v-dialog lazy
                max-width="30em"
                v-model="showAClassRoom">
        <v-card>
          <v-card-text>
            <template v-if="fetchingIframeUrl">
              <h3 class="text-xs-center">Loading...</h3>
            </template>
            <template v-else>
              <h2>Have you installed TutorClient</h2>
              <p>The client application can be started from this page only if TutorClient is installed.</p>
              <p>If it is not installed, please download and install it first.</p>
            </template>
            <iframe :src="iframeUrl"
                    frameborder="0"
                    v-if="showAClassRoom && !fetchingIframeUrl"
                    v-show="false"></iframe>
          </v-card-text>
        </v-card> 
      </v-dialog>
      <v-dialog lazy
                max-width="30em"
                v-model="showClassInRoom"> 
        <v-card>
          <v-card-text>
            <template v-if="fetchingClassinIframeUrl">
              <h3 class="text-xs-center">Loading...</h3>
            </template>
            <template v-if="!fetchingClassinIframeUrl && !isClient">
              <h2 style="color:red">Please open the ClassIn client?</h2> 
              <h2>Have you installed ClassIn?</h2>
              <p>The client application can be started from this page only if ClassIn is installed.</p>
              <p>If it is not installed, please download and install it first.</p>
              <p><a href="http://www.eeo.cn/cn/download.html" target="_blank">download</a></p>
            </template>
            <template v-if="!fetchingClassinIframeUrl && isClient">
              <h2 style="color:red">Sorry.we do not support openning Classin.</h2> 
              <h2>Please use Classin directly to take class.</h2>
              <p>If you need to download Classin,please visit their website.</p>
              <p>Classin official website:</p>
              <p>http://www.eeo.cn/cn/download.html</p>
            </template>
            <iframe :src="iframeUrl"
                    frameborder="0"
                    v-if="showClassInRoom && !fetchingClassinIframeUrl"
                    v-show="false"></iframe>   
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-flex xs12 v-if="this.ClassTools===7">
        <span>{{ (this.$store.getters['classTool/parse'](this.info.ClassTools))==null?'':(this.$store.getters['classTool/parse'](this.info.ClassTools))["name"]}}</span>
        <v-btn @click="JoinClassIn()"
               class="text-none blue-button"
               v-if="!info.IsOverClass">Open ClassIn</v-btn>
      </v-flex>
      <v-flex xs12 v-if="this.ClassTools===7 && !info.IsOverClass">
        <strong style="font-size:14px">Area code:+86 &#8195;</strong>
        <strong style="font-size:14px">Account:{{this.info.VirtualPhone}} &#8195;</strong>
        <strong style="font-size:14px"> Password:{{this.info.VirtualPassword}}</strong>
      </v-flex>
      <v-layout sm12
                v-if="this.ClassTools===8"
                fluid
                wrap>
        <v-flex xs24
                sm12>
          <span>{{ (this.$store.getters['classTool/parse'](this.info.ClassTools))==null?'':(this.$store.getters['classTool/parse'](this.info.ClassTools))["name"]}}</span>
          <v-btn @click="JoinAclassroom()" :disabled = "this.loading? true : false"
                 class="text-none blue-button"
                 small
                 v-if="!info.IsOverClass">Open AClassroom</v-btn>
          <v-tooltip bottom  v-if="!info.IsOverClass && !isClient">
            <v-btn small
                   class="text-none blue-button"
                   href="https://tutor.acadsoc.ph/tutorClient"
                   slot="activator">
              <v-icon small
                      left>get_app</v-icon>Download TutorClient
            </v-btn>
            <span>Download TutorClient</span>
            <v-flex xs12>The account and password are the same as the system's account and password.</v-flex>
          </v-tooltip>
        </v-flex>
      </v-layout>
       <v-flex xs12 v-if="this.ClassTools===9">
        <span>{{ (this.$store.getters['classTool/parse'](this.info.ClassTools))==null?'':(this.$store.getters['classTool/parse'](this.info.ClassTools))["name"]}}</span>
         <v-btn  v-if="info.IsOverClass"
                   small
                   class="text-none blue-button"
                   href="GameClass://"
                   slot="activator">Open GameClass
            </v-btn>
         <v-btn  v-if="info.IsOverClass"
                   small
                   class="text-none blue-button"
                   href="http://tutor.acadsoc.ph/tclient/GameClass.sfx.exe"
                   slot="activator">Download
            </v-btn>
            <br><strong   v-if="info.IsOverClass">The account and password are the same as the system's account and password.</strong>
      </v-flex> 
    </v-layout> 
    <v-layout sm12
                v-if="this.ClassTools===10"
                fluid
                wrap>
        <v-flex xs24
                sm12>
          <span>{{ (this.$store.getters['classTool/parse'](this.info.ClassTools))==null?'':(this.$store.getters['classTool/parse'](this.info.ClassTools))["name"]}}</span>
          <v-btn @click="JoinClassInSDK()" :disabled = "this.loading? true : false"
                 class="text-none blue-button"
                 small
                 v-if="!info.IsOverClass">Open AcsPro+</v-btn>        
          <v-btn @click="OpenPicture()"  class="text-none blue-button" small v-if="showPicture">Designated AI Story</v-btn>    
          <p v-if="!info.IsOverClass" style="color:red">Must Enter AcsPro+ From Tutor Client APP ONLY, Not Website Page!</p>
        </v-flex>
    </v-layout>
    <v-layout sm12
                v-if="this.ClassTools===11"
                fluid
                wrap>
        <v-flex xs24
                sm12>
          <span>{{ (this.$store.getters['classTool/parse'](this.info.ClassTools))==null?'':(this.$store.getters['classTool/parse'](this.info.ClassTools))["name"]}}</span>
          <v-btn @click="JoinTencent()" :disabled = "this.loading? true : false"
                 class="text-none blue-button"
                 small
                 v-if="!info.IsOverClass">Open Tencent Classroom</v-btn>     
          
          <v-tooltip bottom content-class="need-training-tooltip" v-if="info.TrainingTag">
            <template  v-slot:activator="{ on }">
              <v-btn v-on="on" @click="openVideoTrain(info.TrainingTag)" :class="info.IsNeedTraining?'need-train-btn':''" class="text-none video-train-button" small >
                Video training
              </v-btn>  
            </template>
            <span>Tutor must complete this training, ortherwise you class fee will be affected!</span>
        </v-tooltip>
        
          <span v-if="info.IsNeedTraining" class="cursor-pointer">
            <v-tooltip bottom content-class="need-training-tooltip">
                <v-icon
                  color="#ff9900"
                  slot="activator"
                  size="18"
                >help</v-icon>
                <span>Training not completed!</span>
              </v-tooltip>
          </span>
          <v-btn @click="OpenPicture()"  class="text-none blue-button" small v-if="showPicture">Designated AI Story</v-btn>    
          <p v-if="!info.IsOverClass" style="color:red">You can't enter Tencent classroom through Firefox browser.</p>
        </v-flex>
    </v-layout>
     <v-flex v-if="loading" xs12 text-xs-center mt-4 pt-4 class="pr-3 pb-4">
        <v-progress-circular indeterminate :size="50" class="blue-title-2"></v-progress-circular>
      </v-flex>
            <!-- <iframe style="width:100%;height:100%;border:0;" allow="camera;microphone" frameBorder="0" id="agoraproxy"  class="mapFrame" ref="mapFrame" src="https://webdemo.agora.io/akasuo/classroom.html"></iframe>  -->
    
    <v-dialog lazy max-width="1000px" v-model="showVideoTrain" persistent>
      <v-card>
        <v-card-title class="title blue-title pa-3 pt-4 ml-2">
            <div class="header-close" title="close" @click="closeVideoTrain"><v-icon>close</v-icon></div>
        </v-card-title>
        <v-card-text>
          <div v-html="videoContent" class="video-train-dialog" ref="videoContainer"></div>
        </v-card-text>
      </v-card> 
    </v-dialog>
  </div>
</template>
<script>
import { JoinClassIn,JoinAclassroom,JoinNetWorkAclassroom,RecordTutorClientJoinClassroom,AddTutorEventLog,getPicturelesson,RecordUserBehavior, GetTutorAccount, GetTencentRoomID, GetCourseTrainingContent } from '@/api/classtable.js'
import { UpdateUserVersion } from '@/api/teachinfo'
import { createNamespacedHelpers } from 'vuex'
import { formatDate } from '@/utils/date'
import { encryption } from '@/utils/encryption'
import { setCookie, getCookie, clearCookie, urlParamsToObject } from '@/utils/tools'
const namespace = 'classDetail' 
import { getTimestamp } from '@/api/system.js'
const { mapGetters } = createNamespacedHelpers(namespace)
export default {  
  computed: {
    ...mapGetters(['info']),
    classTool () {
      return this.$store.getters['classTool/parse'](this.info.ClassTools) || {}
    }
  },
  mounted(){
    this.getIsClient()
    this.getPicturelesson()
  },
  created () {
    this.InitClassInSDK()
  },
  data () {
    return {
      iframeUrl: '', 
      AgoraUrl: '', 
      fetchingIframeUrl: false,
      showAClassRoom: false,
      showClassInRoom:false,
      fetchingClassinIframeUrl:false,
      isClient:false,
      loading:false,
      showAgoraRoom:false,
      showPicture:false,
      picturestr:'',
      showVideoTrain: false,
      videoContent: ''
    }
  },
  props: ['ClassTools'],
  methods: {
    errorTip (msg) {
      return this.$root.$alertTips(msg)
    },
    // 学生档案埋点
    student() {
      var param = {
            title: "classDetail",
            element_content: "进入教室",
            class_id: this.info.CLID,
            tuid: this.$store.state.user.tuid
          }
          AddTutorEventLog(1,JSON.stringify(param)).then(r =>{})
    },
    JoinClassIn () { 
      this.recordUserBehavior()
      this.student();
      var client = getCookie("client")
      if (client=="tutorclient"){
         this.showClassInRoom = true
         this.isClient = true
         RecordTutorClientJoinClassroom(this.info.CLID).then(res => {
            
         })

      }else {
        JoinClassIn(this.info.CLID).then(res => {
        if (res.Success) {
          window.open(JSON.parse(res.Data.Data).url, '_blank')
        } else {
          this.errorTip(res.Message)
          // this.$toasted.error(res.Message)
        }
      })
      }
    },
    JoinClassInSDK (item) {
      this.recordUserBehavior()
      if(window.qt) {
        //获取课程信息
        if (item && Object.keys(item).length > 0){
          var config = {
            Lang: 2
          }
          var strJson = JSON.stringify(config)
          window.nativeBridge.setConfig(strJson)
          window.nativeBridge.openClassroom("86", item['open']['account'], item['open']['schoolId'], item['open']['courseId'], item['open']['lessonId'], 2)
        }
        else{
          this.JoinAclassroom()
        }       
      }
    },
    getPicturelesson(){
      getPicturelesson(this.$router.currentRoute.params.id).then(res => {
        if (res.length > 0) {
          this.picturestr=res
          this.showPicture = true
        }
      })
    },
    OpenPicture(){
      window.open(this.picturestr, '_blank') 
    },
    InitClassInSDK () {
      var _this = this
      if(window.qt) {       
        new QWebChannel(qt.webChannelTransport, function(channel){
          window.nativeBridge = channel.objects.nativeBridge;
          //获取classin的环境配置
          window.nativeBridge.initConfig.connect(function(config) {
              // initConfig(config);
              console.log("initConfig " + config);
          });
          //设置classin环境配置
          window.nativeBridge.setConfigResponse.connect(function(code, desc) {
            console.log("setConfig " + code + ", " + desc);
          });
          //查看启动后的classin状态
          window.nativeBridge.sdkResponse.connect(function(code, desc) {
            _this.loading = false
            console.log("sdkResponse " + code + ", " + desc);
          });

          window.nativeBridge.closeClassroomResponse.connect(function(code, desc) {
            console.log("closeClassroom " + code + ", " + desc);
          });
          //心跳
          window.nativeBridge.heartbeatResponse.connect(function(code, desc) {
            console.log("heartbeat " + code + ", " + desc);
          });

          window.nativeBridge.sensitiveMsgResponse.connect(function(code, desc) {
            console.log("sensitiveMsg " + code + ", " + desc);
          });

          window.nativeBridge.autoEnterClassUrlResponse.connect(function(code, desc) {
            console.log("autoEnterClassUrl " + code + ", " + desc);
          });
          //通用的消息返回接口. 收到消息解析错误会通过该接口发送，一般是消息格式不符合约定
          window.nativeBridge.parserErrorResponse.connect(function(code, desc) {
            console.log("parserErrorResponse " + code + ", " + desc);
          });
          window.nativeBridge.onDocReady();        
        });
       
      }
    },
    JoinAclassroom () {  
      this.recordUserBehavior()
      this.student();
      // var client = getCookie("client")
      var client = ''
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent)
      if(client=="tutorclient") { 
        this.loading=true;

        var clid=this.info.CLID
        var actoken = this.$store.state.user.actoken
        //isMac?1:0) 这里不再判断 20221026
        JoinNetWorkAclassroom(clid,0)
        .then(res => {
          try{
            if (res.Success) {
              if(window.detectSDI){
                  console.log('调用window.detectSDI客户端方法',{clid:clid.toString,actoken})
                  window.detectSDI(clid.toString(),actoken,"https://actoolapi.acadsoc.com.cn")
              }else{
                  console.log('window.detectSDI客户端方法不存在')
              }

              //classinSDK
              if(res.Data && res.Data["ToolType"] && res.Data["ToolType"]==3 && res.Data["Parameter"]){
                console.info('open classinsdk')

                // window.ShowClassinCode=function(log){
                //   console.log('ShowClassinCode:'+log)
                // }

                // window.StartClassin(JSON.stringify(res.Data.Parameter));
                // console.info('window.StartClassin(\''+JSON.stringify(res.Data.Parameter)+'\')')
                this.JoinClassInSDK(res.Data["Parameter"])
                return
              }

              if(res.Data && res.Data["AgoraRoleType"]) {
                  //本地记录是否第一次进入当前教室
                  const localCurrRoomUUID = localStorage.getItem("ROOMUUID")
                  if(localCurrRoomUUID === res.Data.RoomUUID){
                    localStorage.setItem('isFirstLogin',false)
                  }else{
                    localStorage.setItem('isFirstLogin',true)
                    localStorage.setItem("ROOMUUID",res.Data.RoomUUID)
                  }                

                  localStorage.setItem("AGORA_SDK",JSON.stringify(res.Data))
                  this.$store.commit(namespace+"/SET_TEACHING_AGORA",res.Data)
                  this.$router.push({path:'/test'})

                  return
              }

              //this.iframeUrl = res.Data.Url 
              if(isMac){
                window.location.href=res.Data.Url
              }else{
                window.open(res.Data.Url, '_blank') 
              }
            } else {
              this.errorTip(res.Message)
              // this.$toasted.error(res.Message)
            }
          }catch(e){
            this.errorTip('AGORA_SDK FAIL'+e)
            console.log('AGORA_SDK FAIL'+e)
            //this.errorTip('Due to the low version of the TutorClient, you cannot enter the classroom, please update to the latest version!Please open the download page in your browser to update the client. Download link: https://tutor.acadsoc.ph/tutorClient')
          }
        })
        .catch(err => {
          console.error(err)
          this.showAClassRoom = false
          this.errorTip('Fail to connect to the server, please check your network and then refresh and try again', 'error', { width: 500 })
          // this.$toasted.error(
          //  'Fail to connect to server, please check your network'
          // )
        })
        .finally(() => {
           this.fetchingIframeUrl = false
          //  this.loading=false;


           //客户端版本信息收集
           this.UpdateUserVersion(this.info.CLID);
        })
       } 
       else {
        this.loading=true;
        var clid=this.info.CLID
        //isMac?1:0) 这里不再判断 20221026
        JoinNetWorkAclassroom(clid,0) 
        .then(res => {
          try{
            if (res.Success) {
              if(res.Data && res.Data["ToolType"] && res.Data["ToolType"]==3 && res.Data["Parameter"]){
                console.info('open classinsdk')
                this.JoinClassInSDK(res.Data["Parameter"])
                return
              }
              if(res.Data && res.Data["AgoraRoleType"]) {
                  //本地记录是否第一次进入当前教室
                  const localCurrRoomUUID = localStorage.getItem("ROOMUUID")
                  if(localCurrRoomUUID === res.Data.RoomUUID){
                    localStorage.setItem('isFirstLogin',false)
                  }else{
                    localStorage.setItem('isFirstLogin',true)
                    localStorage.setItem("ROOMUUID",res.Data.RoomUUID)
                  }                

                  localStorage.setItem("AGORA_SDK",JSON.stringify(res.Data))
                  this.$store.commit(namespace+"/SET_TEACHING_AGORA",res.Data)
                  this.$router.push({path:'/test'})

                  return
              }

              // if(isMac){
                // window.location.href=res.Data.Url
                this.loading = false
                window.open(res.Data.Url) 
              // }else{
              //   window.open(res.Data.Url) 
              // }
            } else {
              this.errorTip(res.Message)
            }
          }catch(e){
            this.errorTip('AGORA_SDK FAIL'+e)
            console.log('AGORA_SDK FAIL'+e)
          }
        })
        .catch(err => {
          console.error(err)
          this.showAClassRoom = false
          this.errorTip('Fail to connect to the server, please check your network and then refresh and try again', 'error', { width: 500 })
        })
        .finally(() => {
           this.fetchingIframeUrl = false
          //  this.loading=false;
        })
       }  
    },
    getIsClient(){
      var client = getCookie("client")
       if(client=="tutorclient"){
         this.isClient = true
       }else{
         this.isClient = false
       }
    },
    UpdateUserVersion(clid){
      //客户端版本信息收集
      var client = getCookie("client")
      if(client=="tutorclient"){
          var userSoftSDKType = 1;
          var userSoftVersionNum=0;
          var machineID="";
          if(typeof window.acVersion !== 'undefined' && window.acVersion != null){
            //客户端已升级记录版本号
            userSoftSDKType=2;
            userSoftVersionNum=window.acVersion;
          }
          if(typeof window.acMachineId !== 'undefined' && window.acMachineId != null){
            //设备编码
            machineID=window.acMachineId;
          }
          var sUserAgent=navigator.userAgent;
          var isMac = /macintosh|mac os x/i.test(sUserAgent);
          var userOSType=isMac?2:1;
          var UserOsVersionNum="windows";
          if(userOSType==1){
              var isWin2K = sUserAgent.indexOf("Windows NT 5.0") > -1 || sUserAgent.indexOf("Windows 2000") > -1;
              if (isWin2K) UserOsVersionNum = "Win2000";
              var isWinXP = sUserAgent.indexOf("Windows NT 5.1") > -1 || sUserAgent.indexOf("Windows XP") > -1;
              if (isWinXP)  UserOsVersionNum = "WinXP";
              var isWin2003 = sUserAgent.indexOf("Windows NT 5.2") > -1 || sUserAgent.indexOf("Windows 2003") > -1;
              if (isWin2003)  UserOsVersionNum = "Win2003";
              var isWinVista= sUserAgent.indexOf("Windows NT 6.0") > -1 || sUserAgent.indexOf("Windows Vista") > -1;
              if (isWinVista)  UserOsVersionNum = "WinVista";
              var isWin7 = sUserAgent.indexOf("Windows NT 6.1") > -1 || sUserAgent.indexOf("Windows 7") > -1;
              if (isWin7)  UserOsVersionNum = "Win7";
              var isWin10 = sUserAgent.indexOf("Windows NT 10") > -1 || sUserAgent.indexOf("Windows 10") > -1;
              if (isWin10)  UserOsVersionNum = "Win10";
          }else{
            UserOsVersionNum="Mac";
          }
          let params = {
            UserOSType:userOSType,
            UserOsVersionNum:UserOsVersionNum,
            UserSoftSDKType:userSoftSDKType,
            UserSoftVersionNum:userSoftVersionNum,
            MachineID:machineID,
            CLID:clid
          }
          UpdateUserVersion(params).then(res=>{})
      }
    },
    async JoinTencent(){
      await this.recordUserBehavior()
      if(!this.info.roomid){
        let r_id = await GetTencentRoomID(this.info.CLID).then(res => {
          return res
        })
        if(!r_id){
          this.errorTip(`You can only enter the classroom ten minutes before the class starts.`)
          return
        }
      }
      let params
      let email
      if(!this.$store.state.user.account){
        email = await GetTutorAccount().then(res => {
          return res
        })
      }else{
        email = this.$store.state.user.account
      }
      let n_timestamp = await getTimestamp().then(res => {
        return res.data.Body.Timestamp || null
      })
      params = `email=${email}&nick_name=${this.$store.state.user.fullName}&tuid=${this.$store.state.user.tuid}&source=1&roomid=${this.info.roomid}&timestamp=${n_timestamp}`
      window.open(`https://kolify.com/admin/roomList?${params}&token=${encryption(params)}`)
    },
    formatDate(date){
      return formatDate(date,'MM-dd-yyyy hh:mm:ss');
    },
    recordUserBehavior(){ //埋点操作
      const tool = this.$store.getters['classTool/parse'](this.ClassTools)
      const data = {
        userId: this.$store.state.user.tuid,
        startTime: this.formatDate(new Date()),
        endTime: this.formatDate(new Date()),
        labelId: 239,
        customData: {
          '页面来源': localStorage.getItem("isNewClient") == 'true' ? '新客户端' : '非新客户端',
          '工具类型': tool ? tool.name : '-',
          'CLID': this.info.CLID
        }
      }
      RecordUserBehavior(data).then(res => {
        console.log(res);
      })
    },
    videoTrainBehavior(labelId){
      const r_data = {
        userId: this.$store.state.user.tuid,
        startTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
        endTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
        labelId: labelId,
        customData: {
          'CLID': this.info.CLID,
          'TrainingTag': this.info.TrainingTag
        }
      }
      RecordUserBehavior(r_data).then(res => {
        console.log(res);
      }).catch(err => {
          console.log('请求失败: ' + err.message);
      })
    },
    
    openVideoTrain(trainingTag){
      this.videoTrainBehavior(501)
      
      GetCourseTrainingContent(trainingTag, this.info.CLID).then(res => {
        if(res.Content){
          this.showVideoTrain = true
          this.videoContent = res.Content
          this.videoTrainBehavior(503)
          this.$nextTick(() => {
            this.bindVideoEvents();
          });
        }else{
          this.errorTip(`ERROR!`)
          return
        }
      })
    },

    async closeVideoTrain(){
      this.showVideoTrain = false
      await this.videoTrainBehavior(505)
      location.reload()
    },

    bindVideoEvents() {
      const container = this.$refs.videoContainer;
      if (!container) return;
      const videos = container.querySelectorAll('video');
      videos.forEach(video => {
        // 移除旧监听避免重复
        video.removeEventListener('play', this.handleVideoPlay);
        // 添加新监听
        video.addEventListener('play', this.handleVideoPlay);
      });
    },

    handleVideoPlay() {
      this.trackEvent();
    },

    trackEvent() {
      console.log('埋点触发:');
      this.videoTrainBehavior(504)

    }
  },
  beforeDestroy() {
    // 清理工作
    const videos = this.$el.querySelectorAll('video');
    videos.forEach(video => {
      video.removeEventListener('play', this.handleVideoPlay);
    });
  }
}

</script>
<style>
.video-train-button{
  color: #fff !important;
  background: #ff9900 !important;
  border-radius: 4px;
  height: 24px;
  min-width: 80px !important;
  box-shadow: none !important;
}
.need-train-btn{
  animation: scaleAnimation 1s infinite alternate;
}
.need-train-btn .v-btn__content{
    line-height: normal;
  }
@keyframes scaleAnimation {
  from {
    transform: scale(1);
  }

  to {
    transform: scale(1.15);
  }
}
.need-training-tooltip{
  background: #ff9900!important;
  opacity: 1!important;
}

.video-train-dialog table {
  border-collapse: collapse;
  width: 100%;
}
.video-train-dialog th,
.video-train-dialog td {
  padding: 5px;
  border: 1px solid #ddd;
}
</style>
